"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ScreenState_1 = require("../../types/ScreenState");
class ScreenPresenter {
    constructor(parentElement, trackListPresenter, playlistsPresenter) {
        this.parentElement = parentElement;
        this.trackListPresenter = trackListPresenter;
        this.playlistsPresenter = playlistsPresenter;
        this.currentScreen = ScreenState_1.ScreenState.Tracks;
        this.render();
    }
    render() {
        this.parentElement.innerHTML = '';
        if (this.currentScreen === ScreenState_1.ScreenState.Tracks) {
            this.trackListPresenter.render();
        }
        else {
            this.playlistsPresenter.render();
        }
    }
    changeScreen(screenType) {
        this.currentScreen = screenType;
        this.render();
    }
}
exports.default = ScreenPresenter;
